import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	filterByThisIssue: {
		id: 'portfolio-3-portfolio.app-simple-plans.main.tabs.dependencies.issue.drop-menu.filter-by-this-issue',
		defaultMessage: 'Filter by this issue',
		description: 'Label for the menu item which sets the search filter with the current issue',
	},
	issueFilterWithRollupNotSupported: {
		id: 'portfolio-3-portfolio.app-simple-plans.main.tabs.dependencies.issue.drop-menu.issue-filter-with-rollup-not-supported',
		defaultMessage: 'Issue filter is not supported with roll-up',
		description: 'Placeholder to show that the issue filter is not supported with roll-up',
	},
	locateIssueInTimeline: {
		id: 'portfolio-3-portfolio.app-simple-plans.main.tabs.dependencies.issue.drop-menu.locate-issue-in-timeline',
		defaultMessage: 'Locate issue in timeline',
		description: 'Label for the menu item which locates the issue in the timeline tab',
	},
	meatballsMenuAriaLabel: {
		id: 'portfolio-3-portfolio.app-simple-plans.main.tabs.dependencies.issue.drop-menu.meatballs-menu-aria-label',
		defaultMessage: 'Issue actions list',
		description: 'Aria label text for pop-up menu button in dependency report screen',
	},
});
